var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('span',[_vm._v(" Copyright "),_c('strong',[_vm._v("MG Cash")]),_vm._v(" © "+_vm._s(_vm.year)+" - "),_c('strong',[_vm._v("Mega Assessoria")]),_vm._v(" © 2001 - "+_vm._s(_vm.year)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }